export const hourToNum = (h: string) => Number(h.slice(0, 2));

export function nearDots<
  K extends string,
  T extends { hour: string } & Record<K, number>
>(
  a: T | undefined,
  b: T | undefined,
  key: K,
  hourTol = 1,
  valueTol = 1
): boolean {
  if (!a || !b) return false;

  return (
    Math.abs(hourToNum(a.hour) - hourToNum(b.hour)) <= hourTol &&
    Math.abs(a[key] - b[key]) <= valueTol
  );
}